module.exports = __webpack_public_path__ + "img/0Q3B5795_Wood.b2387e83.jpg";